
import {Box, Card, Typography, ListItem, ListItemText, ListItemButton, Link} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const Guides = [
    {
        "title": "Guide for Local Election Officials",
        "url": "/PublicSearch/ViewDocument?id=3010"
      },
      {
        "title": "Trifold Guide for Local Candidates",
        "url": "https://ocpf2.blob.core.windows.net/pdf/guides/trifoldlocalcandidates.pdf"
      },
      {
        "title": "Guide for Municipal Ballot Question Committees",
        "url": "/PublicSearch/ViewDocument?id=3015"
      },
      {
        "title": "Guide for Municipal Political Action Committees",
        "url": "/PublicSearch/ViewDocument?id=3624"
      },
      {
        "title": "Guide for Municipal Candidates Who File Locally",
        "url": "/PublicSearch/ViewDocument?id=3773"
      },
      {
        "title": "Guide for Municipal Write-in Candidates",
        "url": "/PublicSearch/ViewDocument?id=3011"
      },
      {
        "title": "Guide for All Mayoral Candidates, and City Council Candidates in Cities with Populations of more than 65,000",
        "url": "/PublicSearch/ViewDocument?id=3772"
      },
      {
        "title": "Guide: Changing the purpose of a candidate's committee (when a candidate decides to run for another office)",
        "url": "https://ocpf2.blob.core.windows.net/pdf/guides/changingpurposeguide.pdf",
      },
      {
        "title": "Guide: How to transition from a local filer to a state filer",
        "url": "/PublicSearch/ViewDocument?id=73"
      },
      {
        "title": "Guide: How to 'transition out' - for candidates transferring to the local filing level from OCPF",
        "url": "/PublicSearch/ViewDocument?id=3982"
      },
      {
        "title": "Guide: How to Complete and File the M102 Campaign Finance Form, for Local Candidates",
        "url": "/PublicSearch/ViewDocument?id=3353"
      },
      {
        "title": "Guide: How to Amend the M102 Campaign Finance Form, for Local Candidates",
        "url": "/PublicSearch/ViewDocument?id=3325"
      },
      {
        "title": "Guide: How to Report Out-of-Pocket Expenditures, for Local Candidates",
        "url": "/PublicSearch/ViewDocument?id=3346"
      },
      {
        "title": "Guide: How to Account for Credit and Debit Card Fees (Contributions)",
        "url": "/PublicSearch/ViewDocument?id=3928"
      },
      {
        "title": "Guide: How to Forgive Liabilities on the Local Level",
        "url": "https://ocpf2.blob.core.windows.net/pdf/guides/loanforgiveillustratedlocal.pdf"
      }
]


const MunicipalGuideList = (): JSX.Element => {

  return (
    <Box marginTop={5} marginBottom={4}>
      <Box marginBottom={4}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          OCPF Guides for Municipal Filers
        </Typography>
      </Box>
      <Grid container spacing={4} justifyContent={'center'}>
        <Grid size={{xs:12, md:10}}>
          <Box
            padding={2}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
              <Box>
                <Typography fontWeight={700} variant={'subtitle1'} gutterBottom>
                  Municipal E-Guides
                </Typography>
              </Box>
              {
                  Guides?.map((guide, index) =>
                    <Grid size={12} key={index} display="flex" justifyContent={"flex-start"}>
                      <Box
                        component={ListItem}
                        disableGutters
                        width={'auto'}
                        padding={0}
                      >
                        <Box
                          component={ListItemButton}
                          minWidth={'auto !important'}
                        >
                          <MenuBookIcon color="primary" />
                        </Box>
                        <ListItemText primary={<Typography component={Link} href={guide.url} target='_blank' underline='hover' variant='body2'>{guide.title}</Typography>} />
                      </Box>
                    </Grid>
                  )
              }
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MunicipalGuideList;
